import React from "react";
import { AnimatePresence } from "framer-motion";
import { Provider } from "react-redux";
import store from "./src/store";

import "./src/styles/global.scss";

export const wrapRootElement = ({ element }) => {
  return (
    <Provider store={store}>
      <AnimatePresence mode="wait">{element}</AnimatePresence>
    </Provider>
  );
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_path: location.pathname + location.search,
      page_location: window.location.href,
    });
  }
};
